import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper, { Navigation, Autoplay, HashNavigation } from "swiper";

gsap.registerPlugin(ScrollTrigger);

//Polyfill hashchange Event oldURL and newURL attributes for IE 9+
(function () {
    if (!window.HashChangeEvent) {
        let lastURL = document.URL;
        window.addEventListener("hashchange", function (e) {
            let oldURL = lastURL;
            let newURL = document.URL;
            lastURL = newURL;
            Object.defineProperties(e, {
                oldURL: { enumerable: true, configurable: true, value: oldURL },
                newURL: { enumerable: true, configurable: true, value: newURL },
            });
        });
    }
})();

export default class Main {
    constructor() {
        this.init();
    }

    init() {
        this.changeAnimeDelay = 0;
        this.isFirstView = true;

        this.hideRank();
        this.setLoadHash();
        this.swiper();
        this.eventBind();
        this.pageIn();
        this.onScroll();

        window.addEventListener('scroll', this.onScroll.bind(this));
    }

    pageIn() {
        const tl = gsap.timeline({});
        //tl.fromTo(".best-scene__head", 2, { opacity: 0, rotation: "-5deg" }, { opacity: 1, rotation: "0deg" }, 0);
        tl.fromTo(".best-scene__head__l0c", 1, { scaleY: 1 }, { scaleY: 0 }, 0.5);
        tl.fromTo(".best-scene__head__l1", 1, { opacity: 0, rotation: "5deg", y: -20 }, { opacity: 1, rotation: "0deg", y: 0 }, 1.5);
        tl.fromTo(".best-scene__head__l2", 1, { opacity: 0, y: -10 }, { opacity: 1, y: 0 }, 2);
    }

    onScroll() {
        const revealElm = document.querySelectorAll(".js-scrollreveal");

        revealElm.forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: "top 80%",
                onEnter: (self) => {
                    el.classList.add("-reveal");
                },
                //markers: true,
            });
        });


        if(this.isFirstView){

            if(document.querySelector('.slider-wrapper').classList.contains('-reveal')){
                let hash = location.hash.replace('#', '');
                if(hash == '') hash = 'no10';

                const $new = document.querySelector(`.slider-thumbnail-item[data-hash="${hash}"]`);
                this.changeAnime($new.getAttribute("data-rank"));

                this.isFirstView = false;
            }
        }
    }

    setLoadHash() {
        let queryString = window.location.search;
        let queryObject = new Object();
        if (queryString) {
            queryString = queryString.substring(1);
            let parameters = queryString.split("&");

            for (var i = 0; i < parameters.length; i++) {
                let element = parameters[i].split("=");

                let paramName = decodeURIComponent(element[0]);
                let paramValue = decodeURIComponent(element[1]);

                queryObject[paramName] = paramValue;
            }
        }

        //パラメータから初期ハッシュを決定する
        if (queryObject.type) {
            location.hash = `no${queryObject.type}`;
        }
    }

    eventBind() {

        window.addEventListener("hashchange", (e) => {
            //ハッシュがないときはno10をoldに設定
            const hashregx = /\#.*$/;
            const oldHash = e.oldURL.match(hashregx) ? e.oldURL.match(hashregx)[0].replace("#", "") : "no10";
            const newHash = e.newURL.match(hashregx)[0].replace("#", "");

            document.body.classList.remove(`-${oldHash}`);
            document.body.classList.add(`-${newHash}`);

            this.setThumbActive(newHash);
            this.setRadioActive(newHash);
        });

        //ページ読み込み時の初期表示設定
        if (location.hash !== "") {
            const hash = location.hash.replace("#", "");
            this.setThumbActive(hash);
            this.setRadioActive(hash);
            document.body.classList.add(`-${hash}`);
        } else {
            this.setThumbActive("no10");
            this.setRadioActive("no10");
            document.body.classList.add("-no10");
        }

        //ラジオボックスチェック時(labelではなくinputに。)
        const radios = document.querySelectorAll(".c-formRadio__input");

        radios.forEach((el) => {
            el.addEventListener("click", () => {
                const no = el.getAttribute("data-no");
                location.hash = no;
            });
        });

        //resetボタンを押されたとき、ハッシュもクリアする
        const resetbtn = document.querySelector(".best-scene__form__reset");
        resetbtn.addEventListener("click", () => {
            location.hash = "no10";
        });


        const items = document.querySelectorAll('.slider-thumbnail-item');
        items.forEach((item) => {
            item.addEventListener('click', ()=>{
                this.changeAnimeDelay = 0.7;
                const tpos = window.pageYOffset + document.querySelector('.best-scene__result__ttl').getBoundingClientRect().top;
                gsap.to([document.querySelector("html"),document.querySelector("body")], {duration:0.5, scrollTop:tpos-30, ease:'power2.out'});
            });
        });
    }

    setRadioActive(hash) {
        const radios = document.querySelectorAll(".c-formRadio__input");
        radios.forEach((el) => {
            el.checked = false;
            el.parentElement.classList.remove("-active");

            if (el.getAttribute("data-no") === hash) {
                el.checked = true;
                el.parentElement.classList.add("-active");
            }
        });
    }

    setThumbActive(hash) {
        const $old = document.querySelector(".slider-thumbnail-item.-active");
        const $new = document.querySelector(`.slider-thumbnail-item[data-hash="${hash}"]`);

        this.setRank($new, $old);

        $old && $old.classList.remove("-active");
        $new && $new.classList.add("-active");
    }

    swiper() {
        Swiper.use([Navigation, Autoplay, HashNavigation]);

        const swiper = new Swiper(".swiper-container", {
            // Optional parameters
            loop: true,
            speed: 750,
            hashNavigation: {
                watchState: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });

        swiper.on('slideChangeTransitionStart', ()=>{
            this.hideRank();
        });
    }


    setRank($new, $old) {
        const newRank = $new.getAttribute("data-rank");

        if($old !== null) {
            const oldRank = $old.getAttribute("data-rank");
            document.body.classList.remove(`-rank${oldRank}`);
        }

        document.body.classList.add(`-rank${newRank}`);

        if(!this.isFirstView) this.changeAnime(newRank);
    }


    hideRank(){
        gsap.to('.slider-wrapper .rank', {duration:0.35, opacity:0, ease:'power2.out'});
        gsap.to('.best-scene__result__ttl__ntxt', {duration:0.35, opacity:0, ease:'power2.out'});
        gsap.to('.slider-serif__txt', {duration:0.35, opacity:0, ease:'power2.out'});
    }

    changeAnime(newRank){

        // アイコン アニメーション
        const $rankIco = document.querySelector(`.slider-wrapper .rank.-rank${newRank}`);
        if($rankIco){
            gsap.set($rankIco, {opacity:0, scale:1.5});
            gsap.to($rankIco, {duration:0.4, delay:0.2+this.changeAnimeDelay, opacity:1, scale:1, ease:'power2.out'});

            //const $light = $rankIco.querySelector('.rank__light');
            //gsap.to($light, {duration:0.05, delay:0.25+this.changeAnimeDelay, opacity:1, ease:'power2.out'});
            //gsap.to($light, {duration:0.05, delay:0.5+this.changeAnimeDelay, opacity:0, ease:'power2.out'});

            const $kira = $rankIco.querySelector('.rank__kira');
            $kira.classList.add('-current');
        }
        

        // セリフ アニメーション
        let hash = location.hash.replace('#', '');
        if(hash == '') hash = 'no10';
        
        // テキスト アニメーション
        const $text1 = `.best-scene__result__ttl__ntxt.-${hash}`;
        const $text2 = `.slider-serif__txt.-${hash}`;
        gsap.set([$text1, $text2], {opacity:0, y:20, blur:20});
        gsap.to($text1, {duration:0.5, delay:this.changeAnimeDelay, opacity:1, y:0, blur:0, ease:'power2.out'});
        gsap.to($text2, {duration:0.5, delay:0.2+this.changeAnimeDelay, y:0, blur:0, opacity:1, ease:'power2.out'});
        
        this.changeAnimeDelay = 0;
    }
}
